export function initObserver(canvasControls) {
  const revealElements = document.querySelectorAll('.reveal');

  const revealObserver = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('active');
        obs.unobserve(entry.target);
      }
    });
  }, {
    threshold: 0.15,
    rootMargin: '0px 0px -50px 0px'
  });

  revealElements.forEach(el => revealObserver.observe(el));

  // Hero canvas pause when outside viewport
  const heroSection = document.getElementById('hero');
  if (heroSection && canvasControls) {
    const heroObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          canvasControls.start();
        } else {
          canvasControls.stop();
        }
      });
    }, { threshold: 0.05 });

    heroObserver.observe(heroSection);
  }
}
